import { render } from "./Variable.vue?vue&type=template&id=70778a5d&scoped=true"
import script from "./Variable.vue?vue&type=script&lang=js"
export * from "./Variable.vue?vue&type=script&lang=js"

import "./Variable.vue?vue&type=style&index=0&id=70778a5d&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70778a5d"]])

export default __exports__